module.exports = __webpack_public_path__ + "static/media/3789.5cf40e21.jpg";